/**
 * Provides formatting services for commonly used data types.
 */
export namespace FormatService {
	/**
	 * Formats a number as an HWI credit string.
	 * @param value - The number to format
	 * @param precision - The number of decimal places to include
	 * @returns A string representing the formatted credit
	 */
	export function hwiCredit(value: number | undefined, precision?: number): string {
		if (value == undefined || value == null) return "";
		return value.toLocaleString("en-US", {
			minimumFractionDigits: precision ?? 4,
			maximumFractionDigits: precision ?? 4
		});
	}

	/**
	 * Formats a number as a currency string.
	 * @param value - The number to format
	 * @param precision - The number of decimal places to include
	 * @returns A string representing the formatted currency
	 */
	export function currency(value: number | undefined, precision?: number, showCurrencySymbol?: boolean): string {
		if (value == undefined || value == null) return "";
		return value.toLocaleString("en-US", {
			style: showCurrencySymbol ? "currency" : undefined,
			currency: showCurrencySymbol ? "USD" : undefined,
			minimumFractionDigits: precision ?? 2,
			maximumFractionDigits: precision ?? 2
		});
	}

	/**
	 * Formats a number as a weight string.
	 * @param value - The number to format
	 * @param precision - The number of decimal places to include
	 * @returns A string representing the formatted weight
	 */
	export function weight(value : number, precision?: number) : string {
		if (value == undefined || value == null) return "";
		return value.toLocaleString("en-US", {
			minimumFractionDigits: precision ?? 0,
			maximumFractionDigits: precision ?? 5
		});
	}
}